import { GLProgram } from "../program.js";
export class Display extends GLProgram {

    constructor(gl: any, vertex_source: any, fragment_source: any) {
        super(gl, vertex_source, fragment_source);
    }

    static create(templates, gl) {
        var vertex_source = templates.get('photoshop/GL/shaders/display/vertex.glsl');
        var fragment_source = templates.get('photoshop/GL/shaders/display/fragment.glsl');
        var result = new Display(gl, vertex_source, fragment_source);
        result._uniforms['projection'] = gl.getUniformLocation(result._program, 'u_projection');
        result._uniforms['lookat'] = gl.getUniformLocation(result._program, 'u_lookat');
        result._uniforms['zoom'] = gl.getUniformLocation(result._program, 'u_zoom');
        result._uniforms['pan'] = gl.getUniformLocation(result._program, 'u_pan');
        result._uniforms['model'] = gl.getUniformLocation(result._program, 'u_model');
        result._uniforms['texture'] = gl.getUniformLocation(result._program, 'u_texture');
        result._uniforms['invert'] = gl.getUniformLocation(result._program, 'u_invert');
        result._uniforms['has_alpha_texture'] = gl.getUniformLocation(result._program, 'u_has_alpha_texture');
        result._uniforms['alpha_texture'] = gl.getUniformLocation(result._program, 'u_alpha_texture');
        return result;
    }

}